<template>
  <div id="hotGame" class="original">
    <div class="hotgame_box max-width">
      <div class="hotgame_title">热门游戏</div>
      <div class="hotgame_content">
        <ul class="hotgame_list hand" v-for="(item, index) in hotGameList" :key="index"
          @click="tolink(item)">
          <li class="hotgame_li">
            <div class="list_img" @click="">
                <img :src="item.img" alt />
            </div>
            <div class="list_content">
              <div class="title_box">{{ item.name }}</div>
              <div class="descibe_box">
                <div class="version" style="padding-left: 0.04rem">
                  版本：{{ item.cate_name }}
                </div>
                <div class="newOpen" style="padding-left: 0.03rem">
                  上线时间：{{ item.online_time }}
                </div>
                <div class="timeOpen" style="padding-left: 0.03rem">
                  开服时间：{{ item.open_time }}
                </div>
              </div>
              <div class="gw">
                <a style="padding-left: 0.01rem">官网：{{ item.url }}</a>
              </div>
            </div>
          </li>
        </ul>
        <div class="hotgame_list jqqd">敬请期待...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { customText } from '@/utils/key'
import { downloadA } from "@/utils/download";
import { mapState } from 'vuex';
export default {
  data() {
    return {
      currentIndex: -1,
    };
  },
  created() { },
  mounted() {
    // this.init()
  },
  watch: {},
  computed: {
    ...mapState({
      hotGameList: (state) => state.init.hotGameList,
    })
  },
  methods: {
    tolink(item) {
      
      switch (item.type) {
        case 1:
          downloadA(item.url)
          break;
        case 2:
          if (item.content) {
            localStorage.setItem(customText, item.content);
            let href = window.location.href
            window.open(`${href}custom`)
          }
          break;
        case 3:
          if (item.url) {
            this.$router.push({
              path: item.url,
            })
          }
          break;
        default:
          break;
      }
    },
    showbox(index) {
      this.currentIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.hand {
  cursor: pointer;
}

.max-width {
  max-width: 1920px;
  margin: 0 auto;
}

.original {
  height: auto;
  position: relative;
  z-index: 2;
  background-color: #0c0905;
  padding-bottom: 0.2rem;
}

a {
  color: #949494;
}

.nav_pop_enter {
  animation-name: slideDown;
  animation-duration: 0.25s;
  animation-timing-function: linear;
  transform-origin: center top;
}

/* 定义一个动画 */
@keyframes slideDown {
  from {
    transform: scaleY(0);
    opacity: 0;
  }

  to {
    transform: scaleY(1);
    opacity: 1;
  }
}

.nav_pop_leave {
  animation-name: slideDownS;
  animation-duration: 0.2s;
  animation-timing-function: linear;
  transform-origin: center top;
}

/* 定义一个动画 */
@keyframes slideDownS {
  from {
    transform: scaleY(1);
    opacity: 1;
  }

  to {
    transform: scaleY(0);
    opacity: 0;
  }
}

.hotgame_box {
  height: 100%;

  background: url(../../assets/image/pc/bg/142.jpg) no-repeat;
  // background-size: cover;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .hotgame_title {
    width: 100%
      /* 160/192 */
    ;
    height: 0.916667rem
      /* 176/192 */
    ;
    text-align: center;
    line-height: 1.1rem
      /* 176/192 */
    ;
    // background: palegreen;
    font-size: 0.208333rem
      /* 40/192 */
    ;

    color: #f8f3e9;
    font-weight: bold;
  }

  .hotgame_content {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    width: 6.3125rem
      /* 1212/192 */
    ;
    // height: 3.56875rem /* 666/192 */;
    // background: palevioletred;
    box-sizing: border-box;
    flex-wrap: wrap;

    li {
      position: relative;
      z-index: 1;
      width: 1.5rem
        /* 288/192 */
      ;
      height: 1.682292rem
        /* 323/192 */
      ;
      margin-left: 0.078rem
        /* 18/192 */
      ;
      margin-bottom: 0.078rem;
      background: #ffffff;
      border-radius: 0.052083rem
        /* 10/192 */
      ;
      opacity: 1;
      box-sizing: border-box;

      .list_img {
        width: 1.5rem
          /* 288/192 */
        ;
        height: 0.8125rem
          /* 156/192 */
        ;
        margin-bottom: 0.104167rem
          /* 20/192 */
        ;
        border-radius: 0.052083rem
          /* 10/192 */
          0.052083rem
          /* 10/192 */
          0 0;

        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 0.052083rem
            /* 10/192 */
            0.052083rem
            /* 10/192 */
            0 0;
        }
      }

      .list_img:hover {
        .cd_box {
          opacity: 1;
          height: 0.8125rem;
        }
      }

      .cd_box {
        overflow: hidden;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 1.5rem
          /* 288/192 */
        ;
        height: 0;
        transition: 0.4s;
        /* height: 0.8125rem; */
        box-sizing: border-box;
        margin-bottom: 0.104167rem;
        border-radius: 0.052083rem
          /* 10/192 */
          0.052083rem
          /* 10/192 */
          0rem
          /* 0/192 */
          0rem;
        background: rgba(204, 83, 65, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;

        /* animation-name: cd_avtS;
        animation-duration: 0.2s;
        animation-timing-function: ease-in-out;
        transform-origin: center top; */
        .cord_img {
          width: 0.505208rem
            /* 97/192 */
          ;
          height: 0.505208rem
            /* 97/192 */
          ;
          background: #ffffff;
        }

        .dload_box {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .title_box {
            font-size: 0.083333rem
              /* 16/192 */
            ;
            margin-bottom: 0.088542rem
              /* 17/192 */
            ;
            color: #f6f5f4;
            font-weight: bold;
          }

          .dl_img {
            width: 0.177083rem
              /* 34/192 */
            ;
            height: 0.166667rem
              /* 32/192 */
            ;
            margin-bottom: 0.083333rem
              /* 16/192 */
            ;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .dl_text {
            color: #f6f5f4;
            font-weight: bold;
            font-size: 0.083333rem
              /* 16/192 */
            ;
          }
        }
      }

      .cd_avt {
        transition: all 0.6s ease-in-out;
        transform: translateY(0);
      }

      /* 定义一个动画 */
      @keyframes cd_avtS {
        from {
          transform: translateY(-0.8125rem);
          opacity: 0;
        }

        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .list_content {
        margin-left: 0.067708rem
          /* 13/192 */
        ;

        .title_box {
          font-weight: bold;
          color: #393333;
          font-size: 0.083333rem
            /* 16/192 */
          ;
          margin-bottom: 0.04167rem
            /* 20/192 */
          ;
        }

        .descibe_box {
          height: 0.25rem;
          line-height: 0.12rem;
          color: #231c0e;
          font-size: 0.072917rem
            /* 14/192 */
          ;
          margin-bottom: 0.167rem
            /* 20/192 */
          ;
          // padding-left: 0.04rem;
        }

        .gw {
          font-size: 0.072917rem
            /* 14/192 */
          ;
          color: #949494;
          height: 0.165625rem
            /* 51/192 */
          ;
          border-top: 0.005208rem
            /* 1/192 */
            solid #ececec;
          line-height: 0.1625rem
            /* 51/192 */
          ;
          padding-left: 0.03rem;
        }
      }
    }

    .jqqd {
      width: 1.5rem
        /* 288/192 */
      ;
      height: 1.682292rem
        /* 323/192 */
      ;
      text-align: center;
      line-height: 1.682292rem;
      font-size: 0.09375rem
        /* 18/192 */
      ;
      color: #f6f5f4;
    }
  }
}
</style>
